import { Injectable, inject } from '@angular/core';
import { type UpdateLinkedCardsInput } from '@reconcept-platform/shared/types';
import { LinkedCardsApi } from '../../api/linked-card/linked-cards.api';

@Injectable({
  providedIn: 'root',
})
export class LinkedCardsService {
  private linkedCardApi = inject(LinkedCardsApi);

  updateLinkedCards(updateLinkedCardsInput: UpdateLinkedCardsInput, removedCardIds: string[] = []) {
    return this.linkedCardApi.updateLinkedCards(updateLinkedCardsInput, removedCardIds);
  }
}
